<script setup lang="ts">
import draggable from 'vuedraggable';
import { storeToRefs } from 'pinia';
import { getBlock, listSelectableBlocks } from '@/core/block-registry';
import BlockSelect from '@/modules/live-editor/components/content-blocks/BlockSelect.vue';
import { useLiveEditorStore } from '@/modules/live-editor/stores/live-editor.store';

const { blocks } = storeToRefs(useLiveEditorStore());

const blocksList = computed(() => {
   void blocks.value.length; // refresh uuid when blocks change so there is no collusion in vue-draggable keys

   return listSelectableBlocks().map((def) => ({
      id: `${crypto.randomUUID()}_${def.id}`,
      type: def.id,
      data: def.defaultData ?? {},
   }));
});
</script>

<template>
   <section>
      <h2>{{ $t('live-editor.add-content-block') }}</h2>
      <draggable v-model="blocksList" :group="{ name: 'blocks', pull: 'clone', put: false }" :sort="false" item-key="id">
         <template #item="{ element }">
            <BlockSelect
               :name="$t(getBlock(element.type)?.i18n?.name || '')"
               :description="$t(getBlock(element.type)?.i18n?.description || '')"
               :imageSrc="$t(getBlock(element.type)?.i18n?.image || '')"
            />
         </template>
      </draggable>
   </section>
</template>
